import store from '../store/index';

export default {
  GetTestTypeText(testType) {
    const testTypes = store.getters.serviceTypes;
    for (let i = 0; i < testTypes.length; i += 1) {
      if (testTypes[i].TestTypeCode === testType) {
        return testTypes[i].Name;
      }
    }
    return 'Automobile (class D)';
  },
  GettTestTypeId(testType) {
    const testTypes = store.getters.serviceTypes;
    for (let i = 0; i < testTypes.length; i += 1) {
      if (testTypes[i].TestTypeCode === testType) {
        return testTypes[i].TypeId;
      }
    }
    return 1;
  },
  GetTestType(testTypeText) {
    const testTypes = store.getters.serviceTypes;
    for (let i = 0; i < testTypes.length; i += 1) {
      if (testTypes[i].Name === testTypeText) {
        return testTypes[i].TestTypeCode;
      }
    }
    return 'D';
  },
};
